import numeral from 'numeral';
import numberToWords from 'number-to-words';

const percentage = (value) => numeral(value).format('0.[00]%');

const separator = (value) => numeral(value).format('0,0');

const currency = (value) => numeral(value).format('$0,0.00');

const currencyShort = (value) => numeral(value).format('$0,0');

const currencyBig = (value) => numeral(value).format('$0,0.0a');

const currencySmall = (value) => numeral(value).format('$0,0.000');

// AI cost runs from fractions of a cent (one short completion) up to dollars (a page or campaign with
// imagery), so a single fixed precision is wrong at one end or the other: $0,0.00 rounds most individual
// calls to $0.00, and $0,0.000 makes a $12 total unreadable. Three decimals below a dollar, two above, and
// anything under a tenth of a cent named as small rather than shown as nothing.
const currencyAi = (value) => {
  const n = value || 0;
  if (n > 0 && n < 0.001) return '<$0.001';
  return n < 1 ? currencySmall(n) : currency(n);
};

const two_decimals = (value) => numeral(value).format('0.00');

const one_decimal = (value) => numeral(value).format('0.0');

const no_decimal = (value) => numeral(value).format('0');

const no_decimal_abs = (value) => numeral(Math.abs(value)).format('0');

const ordinal_words = (value) => numberToWords.toWordsOrdinal(value);

export default {
  percentage,
  separator,
  currency,
  currencyShort,
  currencyBig,
  currencySmall,
  currencyAi,
  two_decimals,
  one_decimal,
  no_decimal,
  no_decimal_abs,
  ordinal_words
};
